import api from "./api";

export interface Purchaser {
  _id?: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  phoneNumber: string;
  email?: string;
  taxId?: string;
  customerReference?: string;
  notes?: string;
  active?: boolean;
}

export const purchaserService = {
  getAllPurchasers: async (): Promise<Purchaser[]> => {
    const response = await api.get("/purchasers");
    return response.data;
  },

  getPurchaserById: async (id: string): Promise<Purchaser> => {
    const response = await api.get(`/purchasers/${id}`);
    return response.data;
  },

  createPurchaser: async (purchaser: Purchaser): Promise<Purchaser> => {
    const response = await api.post("/purchasers", purchaser);
    return response.data;
  },

  updatePurchaser: async (id: string, purchaser: Purchaser): Promise<Purchaser> => {
    const response = await api.put(`/purchasers/${id}`, purchaser);
    return response.data;
  },

  deletePurchaser: async (id: string): Promise<void> => {
    await api.delete(`/purchasers/${id}`);
  },

  downloadTemplate: async (): Promise<void> => {
    const response = await api.get("/purchasers/template/download", {
      responseType: "blob",
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'purchasers_template.csv');

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
  },

  upload: async (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post("/purchasers/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Keep the old method name for backward compatibility
  uploadPurchasers: async (file: File): Promise<any> => {
    return purchaserService.upload(file);
  },

  downloadAll: async (): Promise<void> => {
    const response = await api.get("/purchasers/download/all", {
      responseType: "blob",
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    // Set filename with timestamp
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    link.setAttribute('download', `purchasers_export_${timestamp}.csv`);

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
  },

  // Keep the old method name for backward compatibility
  downloadAllPurchasers: async (): Promise<void> => {
    return purchaserService.downloadAll();
  },
};
